// utils/accessConfig.ts

export interface RouteAccess {
  path: string;
  label: string;
  showInMenu: boolean;
  icon?: React.FC<any>;
  navGroup?: string;

  requiredPermission?: string;
}

export const ROUTE_CONFIG: RouteAccess[] = [
  {
    path: "/",
    label: "Home",
    showInMenu: false,
  },

  {
    path: "/user",
    label: "Users",
    navGroup: "Admin",
    showInMenu: true,
    requiredPermission: "users.access",
  },

  {
    path: "/register",
    label: "Register",
    navGroup: "Admin",
    showInMenu: true,
    requiredPermission: "users.create",
  },

  {
    path: "/leadsList",
    label: "Client leads",
    navGroup: "Admin",
    showInMenu: true,
    requiredPermission: "users.access",
  },
  {
    path: "/permissions",
    label: "Permissions",
    navGroup: "Admin",
    showInMenu: true,
    requiredPermission: "permissions.manage",
  },
  {
    path: "/products",
    label: "Add products",
    navGroup: "Admin",
    showInMenu: true,
    requiredPermission: "products.access",
  },

  {
    path: "/stores",
    label: "Add stores",
    navGroup: "Admin",
    showInMenu: true,
    requiredPermission: "stores.access",
  },

  {
    path: "/dcinventory",
    label: "Inventory",
    navGroup: "Warehouse",
    showInMenu: true,
    requiredPermission: "inventory.access",
  },

  {
    path: "/storeRequests",
    label: "Store requests",
    navGroup: "Warehouse",
    showInMenu: true,
    requiredPermission: "requests.access",
  },

  {
    path: "/clientRequests",
    label: "Client requests",
    navGroup: "Warehouse",
    showInMenu: true,
    requiredPermission: "requests.access",
  },

  {
    path: "/storeInventory",
    label: "Store Inventory",
    navGroup: "Store",
    showInMenu: true,
    requiredPermission: "inventory.access",
  },

  {
    path: "/clientInventory",
    label: "Products",
    navGroup: "Products",
    showInMenu: true,
    requiredPermission: "client.access",
  },

  {
    path: "/orderHistory",
    label: "Order History",
    navGroup: "Products",
    showInMenu: true,
    requiredPermission: "orders.access",
  },

  {
    path: "/requestInventory",
    label: "Request Inventory",
    navGroup: "Store",
    showInMenu: true,
    requiredPermission: "inventory.request",
  },

  {
    path: "/requestedProducts",
    label: "Requested Products",
    navGroup: "Store",
    showInMenu: true,
    requiredPermission: "requests.view",
  },

  {
    path: "/inventoryApproval",
    label: "Approvals",
    navGroup: "Warehouse",
    showInMenu: true,
    requiredPermission: "inventory.approve",
  },
];

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
};

/**
 * Rounds numeric values to a maximum of 2 decimal places.
 */
const round2 = (value: number): number => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};
